import $ from 'jquery'

export default class ReportSearch {
  constructor(input, list, emptyState) {
    this.input = input
    this.items = list.find('[data-report-name]')
    this.categories = list.find('[data-category-title]')
    this.emptyState = emptyState

    this.attachEvents()
  }

  attachEvents() {
    this.input.on('keyup', (event) => {
      this.filterList(event.target.value)
    })
  }

  filterList(value) {
    this.items.each((_index, item) => {
      const $item = $(item)
      const name = $item.data('report-name')
      if (this.inputValueMatchesName(value, name)) {
        $item.show()
      } else {
        $item.hide()
      }
    })

    this.toggleCategoryTitle()
  }

  toggleCategoryTitle() {
    const items = this.items
    let hiddenCategoriesCounter = 0

    this.categories.each((_index, category) => {
      const $category = $(category)
      const categoryTitle = $category.data('category-title')
      const visibleCategoryItems = items.filter((index) => {
        const $item = $(items[index])
        return (
          $item.data('report-category') === categoryTitle &&
          $item.is(':visible')
        )
      })

      if (visibleCategoryItems.length > 0) {
        $category.show()
      } else {
        $category.hide()
        hiddenCategoriesCounter++
      }
    })

    if (hiddenCategoriesCounter === this.categories.length) {
      this.emptyState.show()
    } else {
      this.emptyState.hide()
    }
  }

  inputValueMatchesName(inputValue, reportName) {
    const name = reportName.toLowerCase()

    return inputValue
      .toLowerCase()
      .split(/\s+/)
      .every((word) => {
        return name.includes(word)
      })
  }
}
